module.exports = __webpack_public_path__ + "static/lightning-table-bordered-a2f7d08f995e7eb17ff760959359cf55.png";